import {
    CamelToUpperSnakeCase,
    ConvertToCamelCaseAndOmit,
    ConvertToUpperSnakeCase,
    UpperSnakeToCamelCase
} from 'skladon-types';

// Convert object from OriginalType to NewType
// Convert object from OriginalType to NewType

// Convert object from OriginalType to NewType

// Convert object from OriginalType to NewType
// Convert object from OriginalType to NewType
export const convertObjectPropertiesToCamelCase = <T extends Record<string, any>, K extends keyof T>(
    obj: T,
    omitKeys: K[]
): ConvertToCamelCaseAndOmit<T, K> => {
    const result: Record<string, unknown> = {};

    Object.keys(obj).forEach((key) => {
        if (obj[key] !== undefined && !omitKeys.includes(key as unknown as K)) {
            // Convert key to camelCase
            const camelCaseKey = key
                .toLowerCase()
                .replace(/_([a-z])/g, (_, letter) => letter.toUpperCase()) as UpperSnakeToCamelCase<typeof key>;

            // Use type assertion to assure TypeScript about the correct type of camelCaseKey
            result[camelCaseKey] = obj[key];
        }
    });

    return result as ConvertToCamelCaseAndOmit<T, K>;
};

// Convert object from NewType back to OriginalType without default values
export const convertObjectPropertiesToUpperSnakeCase = <T extends Record<string, any>>(
    obj: T
): ConvertToUpperSnakeCase<T> => {
    const result: Record<string, unknown> = {};

    Object.keys(obj).forEach((key) => {
        if (obj[key] !== undefined) {
            // Convert key to upper snake case
            const upperSnakeCaseKey = key
                .replace(/[a-z][A-Z]/g, (match) => `${match[0]}_${match[1]}`)
                .toUpperCase() as CamelToUpperSnakeCase<typeof key>;

            result[upperSnakeCaseKey] = obj[key];
        }
    });

    return result as ConvertToUpperSnakeCase<T>;
};

export const camelToUpperSnake = (str: string): string => str.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase();

export const camelToUpperSnakeArray = (array: string[]): string[] => array.map(camelToUpperSnake);

export const upperSnakeToCamel = (str: string): string =>
    str.toLowerCase().replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

export const upperSnakeToCamelArray = (array: string[]): string[] => array.map(upperSnakeToCamel);

export const toEnumValue = <T extends object>(enumType: T, value: string): T[keyof T] => {
    if (Object.values(enumType).includes(value as any)) {
        return value as T[keyof T];
    }
    throw Error(`Invalid enum value ${value}`);
};
